/**
 * Incremental history for spectating a live session.
 *
 * The live-state proxy (`/sdk/sessions/<id>/state?since=<n>`) returns only the
 * history entries from absolute index n on, with `history_since` and
 * `history_total`. GMs without `?since` support ignore it and return the full
 * history without those fields; then the held history is simply replaced.
 *
 * held = { entries: [], next: 0 } where `next` is the `since` for the next poll.
 */
export const EMPTY_LIVE_HISTORY = Object.freeze({ entries: [], next: 0 });

export function liveStateUrl(base, held) {
    const next = held && Number.isInteger(held.next) ? held.next : 0;
    return `${base}${base.includes('?') ? '&' : '?'}since=${next}`;
}

export function mergeLiveHistory(held, data) {
    const prev = held || EMPTY_LIVE_HISTORY;
    const hist = data && Array.isArray(data.history) ? data.history : null;
    if (!hist) return prev;
    const total = Number.isInteger(data.history_total) ? data.history_total : null;
    const since = Number.isInteger(data.history_since) ? data.history_since : null;
    if (since === null || total === null) return { entries: hist, next: 0 };
    if (total < prev.next) return { entries: [], next: 0 }; // game was reset: refetch from 0
    if (since === prev.next) return { entries: prev.entries.concat(hist), next: total };
    return { entries: hist, next: total }; // gap (capped history dropped entries): window only
}
